module.exports = __webpack_public_path__ + "img/varfy.46ed4381.gif";